"use strict";

var _interopRequireWildcard = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
var _defineProperty2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.array.sort");
require("core-js/modules/es6.array.find");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.map");
var _vuex = require("vuex");
var echarts = _interopRequireWildcard(require("echarts"));
var _comment = _interopRequireDefault(require("../components/comment.vue"));
var _index = require("@/utils/index");
var _homeReport = require("@/http/interface/sfe/homeReport");
var _methods = require("@/components/Store/SalesKPIRecord/methods");
var _headerFilter = _interopRequireDefault(require("../components/headerFilter.vue"));
var _AssignTasks = _interopRequireDefault(require("@/components/AssignTasks"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/** services */

var curDateTree = (0, _methods.getCurDateTree)(); // 获取当前时间相关 月份、季度、年份
var mapObj = new Map();
mapObj.set('1', curDateTree.month);
mapObj.set('2', curDateTree.quarter);
mapObj.set('3', curDateTree.year);
var _default = exports.default = {
  components: {
    Commment: _comment.default,
    HeaderFilter: _headerFilter.default,
    AssignTasks: _AssignTasks.default
  },
  data: function data() {
    return {
      headerLabers: ['timeType', 'time'],
      from: 'newProdcut',
      salesForm: {
        type: '',
        // 类型 月度、季度、年度
        value: ''
      },
      saleEchartsData: {
        // 折线图
        chartNameList: [],
        series: []
      },
      showCommentDialog: false,
      currentRow: {},
      activeTab: '3',
      // 表格的tab
      asm_table: {
        loading: false,
        currPage: 1,
        limit: 10,
        total: 0,
        data: [],
        selected: [],
        defaultSort: {
          prop: 'actualCount',
          order: 'descending'
        }
      },
      sr_table: {
        loading: false,
        currPage: 1,
        limit: 10,
        total: 0,
        data: [],
        selected: [],
        defaultSort: {
          prop: 'actualCount',
          order: 'descending'
        }
      },
      sp_table: {
        loading: false,
        currPage: 1,
        limit: 10,
        total: 0,
        data: [],
        selected: [],
        defaultSort: {
          prop: 'actualCount',
          order: 'descending'
        }
      },
      newProductsData: [],
      // 新产品
      productActiveTab: '',
      productActiveTabData: [],
      // tab分类
      filterForm: {
        // 显示用
        productSize: '',
        spFullName: '',
        asmEmpName: '',
        empName: ''
      },
      filterFormVal: {
        productSize: '',
        spSapId: '',
        asmEmpNo: '',
        srEmpNo: ''
      },
      hasSelected: false
    };
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['homeType'])), {}, {
    isShowASMTable: function isShowASMTable() {
      // 默认不显示
      var result = false;
      var functions = this.$store.getters.functions || {};
      var homeType = this.$store.getters.homeType || {};
      if (functions[homeType] && Array.isArray(functions[homeType]) && functions[homeType].includes('ASM_SORT')) {
        result = true;
      }
      return result;
    },
    findValueByType: function findValueByType() {
      return function (type) {
        return mapObj.get(type) || '';
      };
    },
    currentProduct: function currentProduct() {
      var _this = this;
      if (this.newProductsData.length) {
        var target = this.newProductsData.find(function (t) {
          return t.title === _this.productActiveTab;
        });
        if (target) {
          return target;
        } else {
          return {};
        }
      }
      return {};
    }
  }),
  watch: {
    'salesForm.value': {
      deep: true,
      handler: function handler(val, oldVal) {
        if (oldVal && val !== oldVal) {
          // 把筛选项清空
          this.emptyFilterForm();
          // 刷新
          this.initPage();
        }
      }
    },
    'salesForm.type': {
      deep: true,
      handler: function handler(val, oldVal) {
        if (oldVal && val !== oldVal) {
          var value = this.findValueByType(val);
          this.salesForm.value = value;
        }
      }
    }
  },
  created: function created() {
    this.salesForm = (0, _objectSpread2.default)({}, this.$route.query);
  },
  mounted: function mounted() {
    // echart初始化
    this.SALESChat = echarts.init(document.getElementById('id_productLineEchart'));
    // 获取全部分类
    this.fetchNewProductsData('ALL');
  },
  methods: {
    autoCompleteInput: function autoCompleteInput() {
      this.hasSelected = false;
    },
    queryProductNameOpts: function queryProductNameOpts(queryString, cb) {
      if (queryString === '') {
        cb([]);
        return;
      }
      (0, _homeReport.suggestProductNameOpts)({
        size: queryString
      }).then(function (res) {
        cb(res.data || []);
      });
    },
    querySpOpts: function querySpOpts(queryString, cb) {
      if (queryString === '') {
        cb([]);
        return;
      }
      (0, _homeReport.suggestSpOpts)({
        spName: queryString
      }).then(function (res) {
        cb(res.data || []);
      });
    },
    queryAsmOpts: function queryAsmOpts(queryString, cb) {
      if (queryString === '') {
        cb([]);
        return;
      }
      (0, _homeReport.suggestAsmOpts)({
        asmEmpName: queryString
      }).then(function (res) {
        cb(res.data || []);
      });
    },
    querySrOpts: function querySrOpts(queryString, cb) {
      if (queryString === '') {
        cb([]);
        return;
      }
      (0, _homeReport.suggestSrOpts)({
        empName: queryString
      }).then(function (res) {
        cb(res.data || []);
      });
    },
    selectItem: function selectItem(item, valKey, rowKey) {
      this.filterFormVal[valKey] = item[rowKey];
      this.hasSelected = true;
    },
    blurFilterItem: function blurFilterItem(e, labelKey, valueKey) {
      var _this2 = this;
      var value = e.target.value.trim();
      if (value === '') {
        this.filterForm[labelKey] = '';
        this.filterFormVal[valueKey] = '';
      } else {
        setTimeout(function () {
          if (_this2.hasSelected) {
            _this2.hasSelected = false;
            return;
          }
          _this2.querySuggestListAgain(value, labelKey, valueKey);
        }, 500);
      }
    },
    querySuggestListAgain: function querySuggestListAgain(value, labelKey, valueKey) {
      var _this3 = this;
      // 再查一遍，如果只有一个自动补全，其他情况清空
      var promise = null;
      var apiKey = '';
      var apiValue = '';
      if (labelKey === 'productSize') {
        promise = (0, _homeReport.suggestProductNameOpts)({
          size: value
        });
        apiKey = 'tyreSize';
        apiValue = 'tyreSizeSearchKey';
      } else if (labelKey === 'spFullName') {
        promise = (0, _homeReport.suggestSpOpts)({
          spName: value
        });
        apiKey = 'spFullName';
        apiValue = 'spSapId';
      } else if (labelKey === 'asmEmpName') {
        promise = (0, _homeReport.suggestAsmOpts)({
          asmEmpName: value
        });
        apiKey = 'asmEmpName';
        apiValue = 'asmEmpNo';
      } else if (labelKey === 'empName') {
        promise = (0, _homeReport.suggestSrOpts)({
          empName: value
        });
        apiKey = 'empName';
        apiValue = 'empNo';
      }
      promise.then(function (res) {
        if (res.data.length === 1) {
          _this3.filterForm[labelKey] = res.data[0][apiKey];
          _this3.filterFormVal[valueKey] = res.data[0][apiValue];
        } else {
          _this3.filterForm[labelKey] = '';
          _this3.filterFormVal[valueKey] = '';
        }
      });
    },
    emptyFilterForm: function emptyFilterForm() {
      this.filterForm = {
        productSize: '',
        spFullName: '',
        asmEmpName: '',
        empName: ''
      };
      this.filterFormVal = {
        productSize: '',
        spSapId: '',
        asmEmpNo: '',
        srEmpNo: ''
      };
    },
    resetFilterForm: function resetFilterForm() {
      this.emptyFilterForm();
      // 刷新页面
      this.initPage();
    },
    submitFilterForm: function submitFilterForm() {
      // 刷新页面
      this.initPage();
    },
    toSrDetailsPage: function toSrDetailsPage(row) {
      this.$router.push({
        path: '/srDetails',
        query: {
          srEmpNo: row.srEmpNo
        }
      });
    },
    changeProductActiveTab: function changeProductActiveTab() {
      // 更新图表和表格
      this.fetchEchartsData();
      // 请求第一个表格数据
      this.fetchTablePageOne(this.activeTab);
    },
    initPage: function initPage() {
      // 新产品
      this.fetchNewProductsData();
      // 请求数据
      this.fetchEchartsData();
      // 请求第一个表格数据
      this.fetchTablePageOne(this.activeTab);
    },
    fetchTablePageOne: function fetchTablePageOne(activeTab) {
      // tab变化，请求第一页
      if (activeTab === '1') {
        this.asm_table.currPage = 1;
        this.fetchAsmList();
      } else if (activeTab === '2') {
        this.sr_table.currPage = 1;
        this.fetchSrList();
      } else if (activeTab === '3') {
        this.sp_table.currPage = 1;
        this.fetchSpList();
      }
    },
    fetchNewProductsData: function fetchNewProductsData(pattern) {
      var _this4 = this;
      var params = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.salesForm), {}, {
        spId: this.filterFormVal.spSapId,
        asmCode: this.filterFormVal.asmEmpNo,
        srCode: this.filterFormVal.srEmpNo,
        productSize: this.filterFormVal.productSize,
        pattern: pattern || this.productActiveTab
      });
      (0, _homeReport.getNewProductsData)(params).then(function (res) {
        if (pattern === 'ALL') {
          _this4.newProductsData = res.data || [];
          _this4.productActiveTabData = _this4.newProductsData.map(function (t) {
            return t.title;
          });
          _this4.productActiveTab = _this4.productActiveTabData[0];
          // 请求数据
          _this4.fetchEchartsData();
          // 请求第一个表格数据
          _this4.fetchTablePageOne(_this4.activeTab);
        } else {
          _this4.newProductsData = res.data || [];
        }
      });
    },
    fetchEchartsData: function fetchEchartsData() {
      var _this5 = this;
      var params = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.salesForm), {}, {
        size: this.filterFormVal.productSize,
        spSapId: this.filterFormVal.spSapId,
        asmEmpNo: this.filterFormVal.asmEmpNo,
        srEmpNo: this.filterFormVal.srEmpNo,
        pattern: this.productActiveTab
      });
      (0, _homeReport.getSaleDetailLineChart)(params, this.from).then(function (res) {
        _this5.saleEchartsData = {
          chartNameList: res.data.chartNameList || [],
          series: res.data.series || []
        };
        (0, _methods.drawLineSales)(_this5.SALESChat, _this5.salesForm, _this5.saleEchartsData);
      });
    },
    fetchAsmList: function fetchAsmList() {
      var _this6 = this;
      var params = {
        currPage: this.asm_table.currPage,
        limit: this.asm_table.limit,
        smodel: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.salesForm), {}, {
          productName: this.filterFormVal.productSize,
          spSapId: this.filterFormVal.spSapId,
          srEmpNo: this.filterFormVal.srEmpNo,
          asmEmpNo: this.filterFormVal.asmEmpNo,
          pattern: this.productActiveTab,
          vehicleType: 'New Product',
          orderByField: this.asm_table.defaultSort.prop,
          ascOrDesc: this.asm_table.defaultSort.order === 'ascending' ? 'asc' : 'desc'
        })
      };
      this.asm_table.loading = true;
      (0, _homeReport.getSaleASMList)(params, this.from).then(function (res) {
        _this6.asm_table.loading = false;
        _this6.asm_table.data = res.data.items || [];
        _this6.asm_table.total = res.data.totalCount;
      }).catch(function () {
        _this6.asm_table.loading = false;
      });
    },
    fetchSrList: function fetchSrList() {
      var _this7 = this;
      var params = {
        currPage: this.sr_table.currPage,
        limit: this.sr_table.limit,
        smodel: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.salesForm), {}, {
          productName: this.filterFormVal.productSize,
          spSapId: this.filterFormVal.spSapId,
          srEmpNo: this.filterFormVal.srEmpNo,
          asmEmpNo: this.filterFormVal.asmEmpNo,
          pattern: this.productActiveTab,
          vehicleType: 'New Product',
          orderByField: this.sr_table.defaultSort.prop,
          ascOrDesc: this.sr_table.defaultSort.order === 'ascending' ? 'asc' : 'desc'
        })
      };
      this.sr_table.loading = true;
      (0, _homeReport.getSaleSRList)(params, this.from).then(function (res) {
        _this7.sr_table.loading = false;
        _this7.sr_table.data = res.data.items || [];
        _this7.sr_table.total = res.data.totalCount;
      }).catch(function () {
        _this7.sr_table.loading = false;
      });
    },
    fetchSpList: function fetchSpList() {
      var _this8 = this;
      var params = {
        currPage: this.sp_table.currPage,
        limit: this.sp_table.limit,
        smodel: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.salesForm), {}, {
          spId: this.filterFormVal.spSapId,
          asmCode: this.filterFormVal.asmEmpNo,
          srCode: this.filterFormVal.srEmpNo,
          productSize: this.filterFormVal.productSize,
          pattern: this.productActiveTab,
          orderByField: this.sp_table.defaultSort.prop,
          ascOrDesc: this.sp_table.defaultSort.order === 'ascending' ? 'asc' : 'desc',
          prodSize: 'ALL'
        })
      };
      this.sp_table.loading = true;
      (0, _homeReport.getSaleSPList)(params, this.from).then(function (res) {
        _this8.sp_table.loading = false;
        _this8.sp_table.data = res.data.items || [];
        _this8.sp_table.total = res.data.totalCount;
      }).catch(function () {
        _this8.sp_table.loading = false;
      });
    },
    selectionChange: function selectionChange(val, tableName) {
      this[tableName].selected = val;
    },
    sortAsmTable: function sortAsmTable(_ref) {
      var column = _ref.column,
        prop = _ref.prop,
        order = _ref.order;
      if (!order) {
        var newOrder = this.asm_table.defaultSort.order === 'descending' ? 'ascending' : 'descending';
        this.asm_table.defaultSort = {
          prop: 'actualCount',
          order: newOrder
        };
        this.$refs.asmMultipleTable.sort('actualCount', newOrder);
      } else {
        this.asm_table.defaultSort = {
          prop: prop,
          order: order
        };
        this.fetchTablePageOne(this.activeTab);
      }
    },
    sortSrTable: function sortSrTable(_ref2) {
      var column = _ref2.column,
        prop = _ref2.prop,
        order = _ref2.order;
      if (!order) {
        var newOrder = this.sr_table.defaultSort.order === 'descending' ? 'ascending' : 'descending';
        this.sr_table.defaultSort = {
          prop: 'actualCount',
          order: newOrder
        };
        this.$refs.srMultipleTable.sort('actualCount', newOrder);
      } else {
        this.sr_table.defaultSort = {
          prop: prop,
          order: order
        };
        this.fetchTablePageOne(this.activeTab);
      }
    },
    sortSpTable: function sortSpTable(_ref3) {
      var column = _ref3.column,
        prop = _ref3.prop,
        order = _ref3.order;
      if (!order) {
        var newOrder = this.sp_table.defaultSort.order === 'descending' ? 'ascending' : 'descending';
        this.sp_table.defaultSort = {
          prop: 'actualCount',
          order: newOrder
        };
        this.$refs.spMultipleTable.sort('actualCount', newOrder);
      } else {
        this.sp_table.defaultSort = {
          prop: prop,
          order: order
        };
        this.fetchTablePageOne(this.activeTab);
      }
    },
    addCommentByBatch: function addCommentByBatch(tableName, nameKey) {
      this.currentRow = {
        selected: this[tableName].selected,
        nameKey: nameKey,
        params: {
          dateType: this.salesForm.type,
          dateValue: this.salesForm.value
        }
      };
      this.showCommentDialog = true;
    },
    addCommentByRow: function addCommentByRow(row, apiKey, rowKey) {
      var _this9 = this;
      var params = (0, _defineProperty2.default)({}, apiKey, row[rowKey] || '');
      (0, _homeReport.getCommentOrgBiz)(params).then(function (res) {
        _this9.currentRow = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, row), {}, {
          orgBiz: res.data || [],
          params: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, params), {}, {
            dateType: _this9.salesForm.type,
            dateValue: _this9.salesForm.value
          })
        });
      });
      this.showCommentDialog = true;
    },
    submitCommentDialog: function submitCommentDialog(form) {
      if (this.currentRow.hasOwnProperty('selected')) {
        this.submitCommentByBatch(form);
      } else {
        this.submitCommentByRow(form);
      }
    },
    submitCommentByRow: function submitCommentByRow(form) {
      var _this0 = this;
      var empNoList = [].concat((0, _toConsumableArray2.default)(form.asm), (0, _toConsumableArray2.default)(form.sr));
      var params = (0, _objectSpread2.default)((0, _objectSpread2.default)({
        businessType: 1,
        actionLikes: form.actionLikes,
        actionContent: "".concat(form.content, " ").concat(form.desc)
      }, this.currentRow.params), {}, {
        pattern: this.productActiveTab,
        vehicleType: 'New Product',
        originType: 'srDetail',
        empNoList: empNoList
      });
      if (this.activeTab === '1') {
        params.asmEmpNo = params.smEmpNo;
        delete params.smEmpNo;
      }
      (0, _homeReport.getCommentSendSingle)(params).then(function (res) {
        _this0.$message.success(_this0.$t('dashboard.commentSuccess'));
        _this0.closeCommentDialog();
      });
    },
    submitCommentByBatch: function submitCommentByBatch(form) {
      var _this1 = this;
      var p = {};
      if (this.activeTab === '1') {
        p.asmEmpNoList = this.currentRow.selected.map(function (item) {
          return item.asmEmpNo;
        });
      } else if (this.activeTab === '2') {
        p.srEmpNoList = this.currentRow.selected.map(function (item) {
          return item.srEmpNo;
        });
      } else if (this.activeTab === '3') {
        p.spSapIdList = this.currentRow.selected.map(function (item) {
          return item.spId;
        });
      }
      var params = (0, _objectSpread2.default)((0, _objectSpread2.default)({
        businessType: 1,
        actionLikes: form.actionLikes,
        actionContent: "".concat(form.content, " ").concat(form.desc)
      }, this.currentRow.params), {}, {
        pattern: this.productActiveTab,
        vehicleType: 'New Product',
        originType: 'srDetail'
      }, p);
      (0, _homeReport.getCommentSendBatch)(params).then(function (res) {
        _this1.$message.success(_this1.$t('dashboard.commentSuccess'));
        _this1.closeCommentDialog();
      });
    },
    closeCommentDialog: function closeCommentDialog() {
      this.showCommentDialog = false;
      this.currentRow = {};
      // 刷新界面
      if (this.activeTab === '1') {
        this.fetchAsmList();
      } else if (this.activeTab === '2') {
        this.fetchSrList();
      } else if (this.activeTab === '3') {
        this.fetchSpList();
      }
    },
    paddingNum: function paddingNum(inputParam) {
      return (0, _index.paddingNum)(inputParam);
    },
    // 分配任务
    assignTasks: function assignTasks(SRInfo) {
      var param = {
        srEmpName: SRInfo.srEmpNoName,
        srEmpNo: SRInfo.srEmpNo
      };
      this.$refs.AssignTasks.showModel(param, 'srDetail');
    }
  }
};